import {Injectable, NgZone} from '@angular/core';
import {Store} from '@ngrx/store';
import {upsertWebsocketRegistry} from '@spout/web-global/actions';
import {firestoreUserKey_sha256} from '@spout/web-global/fns';
import {
  AuthAccountStates,
  AuthAccountStatesConnect,
  MusicianNotification,
  notificationsesFeatureKey,
  SptFirebaseConnectionService
} from '@spout/web-global/models';
import {selectAuthAccountConnect$} from '@spout/web-global/selectors';
import {SptFirestoreService} from '../firestore';

@Injectable({
  providedIn: 'root'
})
export class SptNotificationsService implements SptFirebaseConnectionService<AuthAccountStates> {
  constructor(
    private store: Store<AuthAccountStatesConnect>,
    private sptFirestore: SptFirestoreService,
    private zone: NgZone
  ) {
    // console.log('Account Service');

    const that = this;
    that.zone.run(() => {
      this.store.dispatch(
        upsertWebsocketRegistry({
          id: notificationsesFeatureKey
        })
      );
    });

    this.store.pipe(selectAuthAccountConnect$).subscribe(s => {
      if (s.doConnect) {
        this.onConnect.call(this, s.user);
      } else {
        this.onDisconnect.call(this);
      }
    });
  }

  /**
   * Save to OTHER user's account
   * @param notification
   */
  sendNotification(notification: MusicianNotification) {
    const docRef = `users/${firestoreUserKey_sha256(notification.targetMusician.uid)}/notifications/${notification.id}`;
    this.sptFirestore.setDoc(docRef, notification.toString());
  }

  onConnect(user: AuthAccountStates): void {
    this.sptFirestore.setWebSocketConnected(notificationsesFeatureKey);
  }

  onDisconnect() {
    this.sptFirestore.setWebSocketDisconnected(notificationsesFeatureKey);
  }
}
